import { backgroundOrange, orange } from '@/theme/colors'
import styled from 'styled-components'

export const HeaderContainer = styled.header`
	background: ${backgroundOrange};
	padding: 1rem 2rem;
	box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
	border-bottom: 1px solid #e1e5e9;
`

export const HeaderContent = styled.div`
	max-width: 1200px;
	margin: 0 auto;
	display: flex;
	justify-content: space-between;
	align-items: center;
`

export const Logo = styled.h1`
	color: #2c3e50;
	font-size: 2rem;
	font-weight: 700;
	margin: 0;
`

export const Nav = styled.nav`
	display: flex;
	gap: 2rem;
`

export const NavLink = styled.a`
	color: white;
	text-decoration: none;
	font-weight: 500;
	padding: 0.5rem 1rem;
	border-radius: 8px;
	transition: all 0.3s ease;

	&:hover {
		background: rgba(255, 255, 255, 0.2);
		transform: translateY(-2px);
	}
`

export const HeaderActions = styled.div`
	display: flex;
	align-items: center;
	gap: 1rem;
`

export const BackButton = styled.button`
	background: #f8f9fa;
	color: #495057;
	border: 1px solid #dee2e6;
	padding: 0.5rem 1rem;
	border-radius: 8px;
	font-weight: 500;
	cursor: pointer;
	transition: all 0.2s ease;

	&:hover {
		background: #e9ecef;
		border-color: #adb5bd;
	}
`

export const MyTripsButton = styled.button`
	background: ${orange};
	color: white;
	border: 1px solid ${orange};
	padding: 0.5rem 1rem;
	border-radius: 8px;
	font-weight: 500;
	cursor: pointer;
	transition: all 0.2s ease;
	display: flex;
	align-items: center;
	gap: 0.5rem;

	&:hover {
		opacity: 0.9;
		transform: translateY(-1px);
		box-shadow: 0 2px 8px rgba(209, 95, 42, 0.3);
	}
`

export const MyProfileButton = styled.button`
	background: ${orange};
	color: white;
	border: 1px solid ${orange};
	padding: 0.5rem 1rem;
	border-radius: 8px;
	font-weight: 500;
	cursor: pointer;
	transition: all 0.2s ease;
	display: flex;
	align-items: center;
	gap: 0.5rem;

	&:hover {
		opacity: 0.9;
		transform: translateY(-1px);
		box-shadow: 0 2px 8px rgba(209, 95, 42, 0.3);
	}
`

export const LogoutButton = styled.button`
	background: #dc3545;
	color: white;
	border: 1px solid #dc3545;
	padding: 0.5rem 1rem;
	border-radius: 8px;
	font-weight: 500;
	cursor: pointer;
	transition: all 0.2s ease;

	&:hover {
		background: #c82333;
		border-color: #bd2130;
	}
`
